// filepath: /home/nasiha/cheche/qetero/qetero_web/app/src/components/schedule-page-skeleton.tsx
import React from "react"
import { Skeleton } from "@/components/ui/skeleton"
import SlotsSkeleton from "@/components/slots-skeleton"
import BookingSummarySkeleton from "./booking-summary-skeleton"

export default function SchedulePageSkeleton() {
  return (
    <div>
      {/* progress pill */}
      <div className="mt-1 mb-3">
        <Skeleton className="h-3 w-4/5 px-4 rounded-full" />
      </div>

      <h2 className="text-base font-bold text-gray-900 mb-2">
        <Skeleton className="h-6 w-48 rounded-md" />
      </h2>

      {/* Date Card */}
      <div className="rounded-xl border border-gray-200 bg-white p-3 pb-10 pt-6 mb-3 shadow-[0_2px_6px_rgba(0,0,0,0.04)] md:px-8">
        {/* header (branch + month) */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <Skeleton className="w-10 h-10 rounded-full" />
            <div>
              <Skeleton className="h-4 w-36 rounded-md mb-1" />
              <Skeleton className="h-3 w-28 rounded-md" />
            </div>
          </div>
          <Skeleton className="h-5 w-32 rounded-md" />
        </div>

        {/* week strip skeleton (days) */}
        <div className="grid grid-cols-7 gap-3 mt-2">
          {Array.from({ length: 7 }).map((_, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <Skeleton className="w-8 h-8 rounded-full" />
              <Skeleton className="h-3 w-8 rounded-md" />
            </div>
          ))}
        </div>

        <div className="flex-1 border-t border-dashed border-gray-200 my-6 md:my-8 mx-3 " />

        {/* time slots skeleton */}
        <SlotsSkeleton />
      </div>
    </div>
  )
}